module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/911ef52fdb429b1c3e80a364a1f17d7f.png";